import { render, staticRenderFns } from "./cwpay.vue?vue&type=template&id=8b7361e0&scoped=true"
import script from "./cwpay.vue?vue&type=script&lang=js"
export * from "./cwpay.vue?vue&type=script&lang=js"
import style0 from "./cwpay.vue?vue&type=style&index=0&id=8b7361e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7361e0",
  null
  
)

export default component.exports